type CircleProps = {
  size?: number;
  color?: string;
};

const Circle = ({ color = "#6B97F6", size = 50 }: CircleProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2.2}
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Circle;
